export const SW_UPDATE = 'serviceWorker/update';

/**
 * Called to trigger to update of the service worker.
 * @param registration the registration
 */
export const updateServiceWorker = (registration) => ({
    type: SW_UPDATE,
    registration
});